import React from "react";
import { AccessRequired } from "../../../common/AccessRequired";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import EmployeeTransactionModule from "../../components/modules/EmployeeTransactions/EmployeeTransactionModule";
import { FEATURES } from "../../../config/features";

const EmployeeTransactionPage = ({ user, userAccess, isHideSideMenu }) => {
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  const hasAccess =
    userAccess?.isEmployeeTransactionProcessManager ||
    userAccess?.isEmployeeTransactionAssignedEmployee;

  // REPLACED: Updated the logic to handle feature flags vs user permissions
  const isAllowedModule = FEATURES.ALLOW_EMPLOYEE_TRANSACTION_MODULE;

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="EmployeesTabInfo shadow-xl bg-white rounded-lg overflow-hidden">

          <div className="employeesTab-header p-4 border-b">
            <div className='sub-title row text-sm'>
              <span className="text-gray-400">{"Personnel > "}</span>
              <span className="border-b border-black">{"Employee Transactions"}</span>
            </div>
            <h3 className="text-xl font-bold mt-2">Employee Transactions</h3>
          </div>

          <div className='p-4'>
            {/* MODIFIED: Nested logic - Check if module exists/allowed first, then check user permissions */}
            {!isAllowedModule ? (
              <AccessRequired
                isAllowed={false}
                restrictedTitle="Not Available for your organization."
                restrictedMessage="This module is unavailable for your organization's specific requirements."
              />
            ) : hasAccess ? (
              <EmployeeTransactionModule
                user={user}
                userAccess={userAccess}
                showGeneralMessage={showGeneralMessage}
              />
            ) : (
              <div className="flex justify-center mt-8">
                <div className="w-full max-w-2xl">
                  <AccessRequired
                    userAccess={userAccess}
                    moduleName={"Employee Transaction Access"}
                    pathName={"/employeeTransactionAccess"}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
    </div>
  );
};

export default EmployeeTransactionPage;